import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddImage = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 1.09375C12.5261 1.09375 12.75 1.31761 12.75 1.59375V3.8125H14.9688C15.2449 3.8125 15.4688 4.03636 15.4688 4.3125C15.4688 4.58864 15.2449 4.8125 14.9688 4.8125H12.75V7.03125C12.75 7.30739 12.5261 7.53125 12.25 7.53125C11.9739 7.53125 11.75 7.30739 11.75 7.03125V4.8125H9.53125C9.25511 4.8125 9.03125 4.58864 9.03125 4.3125C9.03125 4.03636 9.25511 3.8125 9.53125 3.8125H11.75V1.59375C11.75 1.31761 11.9739 1.09375 12.25 1.09375ZM2 4.5C2 3.67157 2.67157 3 3.5 3H7.4375C7.71364 3 7.9375 2.77614 7.9375 2.5C7.9375 2.22386 7.71364 2 7.4375 2H3.5C2.11929 2 1 3.11929 1 4.5V12.5C1 13.8807 2.11929 15 3.5 15H11.5C12.8807 15 14 13.8807 14 12.5V11.1875C14 11.0336 13.9305 10.8959 13.8211 10.8042C13.8065 10.7868 13.7906 10.7702 13.7732 10.7545L10.7733 8.03576C10.5851 7.86527 10.2991 7.86283 10.1081 8.03009L6.7534 10.9678L4.18888 9.04444C3.98982 8.89515 3.71128 8.91494 3.53533 9.09089L2 10.6262V4.5ZM10.4318 9.07586L13 11.4033V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V12.0404L3.9358 10.1046L6.47777 12.0111C6.66684 12.1529 6.92937 12.143 7.10717 11.9873L10.4318 9.07586ZM7 6.66519C7 7.01037 6.72018 7.29019 6.375 7.29019C6.02982 7.29019 5.75 7.01037 5.75 6.66519C5.75 6.32001 6.02982 6.04019 6.375 6.04019C6.72018 6.04019 7 6.32001 7 6.66519ZM8 6.66519C8 7.56265 7.27246 8.29019 6.375 8.29019C5.47754 8.29019 4.75 7.56265 4.75 6.66519C4.75 5.76773 5.47754 5.04019 6.375 5.04019C7.27246 5.04019 8 5.76773 8 6.66519Z"
        fill={color}
      />
    </svg>
  )
})

export default AddImage
